import React, {useState, useContext, useEffect} from 'react'
import { LogoContext } from '../../contexts/LogoContext';

const ToggleWatermark = () => {
  const [hidden, setHidden] = useState(false);
  const { logos, dispatch } = useContext(LogoContext);
  const handleClick = () => {
    const logo = document.querySelector('.zoomback');
    if (hidden) {
      logo.classList.remove('zoomback-hide');
      setHidden(false);
    } else {
      logo.classList.add('zoomback-hide');
      setHidden(true);
    }
  }
  useEffect(() => {
    dispatch({ type: 'UPDATE_WATERMARK', watermarkHidden: hidden});
  }, [hidden])
  return (
    <button onClick={handleClick}>
      Toggle Watermark <i class="fas fa-star-half-alt"></i>
    </button>
  )
}

export default ToggleWatermark;
